var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23828 21.7031C6.65613 18.3608 9.60027 16.064 13.0024 16.064C16.4045 16.064 19.3486 18.3608 20.7664 21.7031C15.4092 25.0865 13.0024 24.9998 13.0024 24.9998C13.0024 24.9998 7.70721 23.9587 5.23828 21.7031Z",
    fill: "#828A9A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0005,
    cy: 11.2261,
    r: 2.96338,
    fill: "#828A9A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    stroke: "#828A9A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.fdcaf9decb7996dd4a7b101ad8b69291.svg";
export { ForwardRef as ReactComponent };